import { QueryHookOptions, useQuery } from '@apollo/client';

import allSentinelTeamsQuery from './allSentinelTeams.graphql';

export default function useSentinelTeamsQuery(
  options: QueryHookOptions<SentinelTeamsQuery, SentinelTeamsQueryVariables>,
) {
  return useQuery<SentinelTeamsQuery, SentinelTeamsQueryVariables>(
    allSentinelTeamsQuery,
    options,
  );
}
